import internalApi from "../../../api/internal/internalApi";
import tochtTypeApi from "../../../api/shared/tochtTypeApi";
import { showToastrSuccess, showToastrError } from "../../../util/toastr";
import * as messages from "../../../constants/ToastrConstants";

export default class UitInVlaanderenPageHelper {
    constructor(context, redirector) {
        this.context = context;
    }

    init() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;

        ajaxActions.started();
        tochtTypeApi.getTochtTypes()
            .then((response) => {
                ajaxActions.ended();
                context.setState({
                    tochtTypes: response.data.map(k => { return { value: k.id, label: k.naam }; })
                });
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }

    save() {
        const context = this.context;
        const state = context.state;
        const fileName = state.fileName;
        const content = state.content;
        const tochtTypeId = state.tochtTypeId;
        const ajaxActions = context.props.ajaxActions;

        if (!tochtTypeId) {
            showToastrError("U moet eerst een tochttype kiezen!");
            return;
        }

        if (fileName == "" || content.length == 0) {
            showToastrError("U moet eerst een afbeelding uploaden!");
            return;
        }

        ajaxActions.started();
        internalApi.saveFoto(fileName, content, tochtTypeId)
            .then((response) => {
                ajaxActions.ended();
                showToastrSuccess(messages.MESSAGE_PHOTO_SAVED, true);
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }

    dropBestand(files) {
        const file = files[0];
        const reader = new FileReader();
        const context = this.context;

        if (file.size > 4718600) {
            showToastrError("Afbeelding mag niet groter zijn dan 4,5 MB");
            return;
        }

        reader.onload = function (e) {
            let img = new Image();
            img.src = reader.result;

            const content = reader.result.split(",")[1];

            context.setState({
                content
            });
        };

        reader.readAsDataURL(file);

        context.setState({
            fileName: file.name
        });
    }
}
